import merge from 'lodash/merge';

import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.twitterApiUrl);
export const httpCamelCase = createDashHttpClient(env.twitterApiUrl, {
  camelizeKeys: true,
});

export const fetchUsers = ({ handles, brandId }, config = {}) =>
  httpCamelCase.get(`/users`, {
    ...config,
    params: { handles, brandId },
  });

export async function getTwitterAccount({ brandId }, config = {}) {
  return http.get(`/brands/${brandId}/account`, config);
}

export async function getTwitterAccounts({ brandIds }, config = {}) {
  return http.get(
    `/brands/accounts`,
    merge(
      {
        params: {
          brandIds: brandIds.join(','),
        },
      },
      config,
    ),
  );
}

export async function refreshTwitterAdsAccount({ brandId }, config = {}) {
  return http.post(`/brands/${brandId}/account/refresh/ads_account`, config);
}

export async function getFollowersCSV({ brandId, filename, startDate, endDate, scale }, config) {
  return http.get(
    `/brands/${brandId}/exports/followers`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function getMetricsCSV({ brandId, filename, startDate, endDate, scale }, config) {
  return http.get(
    `/brands/${brandId}/exports/metrics`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function getAllTweetsCSV({ brandId, filename, startDate, endDate, scale }, config) {
  return http.get(
    `/brands/${brandId}/exports/all_tweets`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function getTopTweetsCSV(
  { brandId, filename, startDate, endDate, scale, sortOrder },
  config,
) {
  return http.get(
    `/brands/${brandId}/exports/top_tweets`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
          sortOrder,
        },
      },
      config,
    ),
  );
}

export async function getAccountMetrics({ brandId, startDate, endDate, scale }, config) {
  return http.get(
    `/brands/${brandId}/metrics`,
    merge(
      {
        params: {
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function addAccount({ handle }, config = {}) {
  return http.post(`/public_accounts/${handle}`, config);
}

export async function getPublicAccountsByIds({ twitterUserIds }, config = {}) {
  return httpCamelCase.post('/public_accounts', { twitterUserIds }, config);
}

export async function getTwitterSearchCounts(
  { topicQuery, bucket, fromDate, toDate },
  config = {},
) {
  return http.get(
    `/twitter_search/counts`,
    merge(
      {
        params: {
          topicQuery,
          bucket,
          fromDate,
          toDate,
        },
      },
      config,
    ),
  );
}
